module.exports = {"data":{"site":{"siteMetadata":{"domain":"www.fileforein.com","supportEmail":"support@FileForEIN.com","title":"File For EIN","supportPhone":"888-375-8904"}}},"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/privacy-policy.json
// module id = 722
// module chunks = 231881910887020